// extracted by mini-css-extract-plugin
export default {"container":"UploadStats__container___pMwLr"};